import { ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    title: "Share your date",
    copy: "Tell us when and where the good times happen — venue, guest count, the vibe.",
  },
  {
    num: "02",
    title: "Pick your package",
    copy: "Bartender and bar kit, or the works with signature cocktails.",
  },
  {
    num: "03",
    title: "We roll in & pour",
    copy: "We show up early, set up slick, and keep the glasses full until the last toast.",
  },
];

export default function Manifesto() {
  return (
    <section id="about" data-testid="about-section" className="bg-cream px-5 py-24 sm:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <span className="eyebrow text-espresso/50">The Society</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-4xl font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl">
            Proof that great hospitality <em className="italic text-rose">travels</em> — bar kit,
            fresh garnish and a shaker that never stops.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-espresso/70 sm:text-lg">
            Shaken Society is a dry hire mobile bar serving the La Cantera to Boerne area.
            We turn any venue — ballroom, backyard or barn — into a proper bar
            experience without the liquor-store runs or the DIY stress.
          </p>
          <p className="mt-3 text-[11px] tracking-wide text-espresso/45" data-testid="about-area-note">
            Based in the La Cantera–Boerne corridor — events outside a 30-mile radius are subject to an upcharge.
          </p>
          <div
            className="mt-7 inline-flex items-center gap-2.5 rounded-full border border-gold/50 bg-gold/10 px-5 py-2.5"
            data-testid="about-tabc-badge"
          >
            <ShieldCheck className="h-4 w-4 text-espresso" />
            <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-espresso">
              TABC certified & compliant staff
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.24}>
          <blockquote
            data-testid="about-experience"
            className="mt-12 max-w-3xl border-l-2 border-gold pl-6 sm:pl-8"
          >
            <p className="font-display text-2xl leading-snug sm:text-3xl">
              Between me and my partner, we have over two decades of experience bartending &
              event planning — from country clubs to night clubs — and we can execute
              <em className="italic text-rose"> any function.</em>
            </p>
            <p className="mt-4 text-xs font-semibold uppercase tracking-[0.24em] text-espresso/50">
              — Jasmine, Shaken Society
            </p>
          </blockquote>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-3xl border border-espresso/10 bg-espresso/10 sm:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.12} className="h-full">
              <div className="h-full bg-cream p-8 transition-colors duration-300 hover:bg-blush-soft" data-testid={`about-step-${s.num}`}>
                <span className="font-display text-5xl italic text-gold">{s.num}</span>
                <h3 className="mt-5 font-display text-2xl">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-espresso/65">{s.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}